import { message } from 'antd';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { push } from 'connected-react-router';
import APP_MESSAGE from 'constant/message';
import APP_ROUTE from 'constant/route';
import { getCompanyId, getOrgCode, getStaffId, getUserId, getUserToken, setLoginRedirectUrl } from 'data/storage';
import store from 'model';
import { appRedirectAfterLogout, resetAppData } from 'model/app';
import { from } from 'rxjs';
import cooperationSDK from 'lib/cooperationSdk';
import { isSSO } from 'util/crossenv';
import { v4 as uuidv4 } from 'uuid';

export function generateUUIDWithoutHyphens() {
  const uuid = uuidv4();
  return uuid.replace(/-/g, '');
}
class Request {
  private namespace = '';

  private instance: AxiosInstance;

  private addNamespaceUrl(url: string) {
    if (this.namespace) {
      if (this.namespace === 'trigger') {
        return '/'.concat(this.namespace).concat(url);
      } else {
        return '/api-'.concat(this.namespace).concat(url);
      }
    }

    return url;
  }

  constructor(namespace: string, options?: AxiosRequestConfig) {
    this.namespace = namespace;
    this.instance = axios.create(options);
    this.interceptorInit();
  }

  private interceptorInit() {
    this.instance.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Bearer ${getUserToken()}`,
        'x-auth-userId': getUserId(),
        'x-staff-id': getStaffId(),
        'x-company-id': getCompanyId(),
        'x-org-code': getOrgCode(),
        'x-isp-traceid': generateUUIDWithoutHyphens(),
        ...config.headers
      };

      return config;
    });

    this.instance.interceptors.response.use(
      (response) => {
        console.log('interceptors response', response);

        return response.data;
      },
      (error) => {
        console.log('interceptors error', error);

        if (!navigator.onLine) {
          message.error(APP_MESSAGE.NETWORK_OFFLINE);
          return Promise.reject(error);
        }

        if (error.response.status === 500) {
          message.error(APP_MESSAGE.SERVER_EXCEPTION);
        }

        if (error.response.status === 401) {
          const url = window.location.pathname;
          if (url.indexOf('early-end') > -1) {
            setLoginRedirectUrl(url);
          }
          // TODO: hack 通过延时防止rootEpic没有捕获到导致错误的程序中断
          setTimeout(() => {
            store.dispatch(resetAppData);
            isSSO() ? store.dispatch(appRedirectAfterLogout()) : store.dispatch(push(cooperationSDK.isCoEnv ? APP_ROUTE.NONE : APP_ROUTE.LOGIN));
          }, 200);
        }
        // 这里需抛出错误，否则catchError捕获不到
        return Promise.reject(error);
      }
    );
  }

  get<T = any, R = T>(url: string, config?: AxiosRequestConfig) {
    return from(this.instance.get<T, R>(this.addNamespaceUrl(url), config));
  }

  post<T = any, R = T>(url: string, data?: any, config?: AxiosRequestConfig) {
    return from(this.instance.post<T, R>(this.addNamespaceUrl(url), data, config));
  }

  delete<T = any, R = T>(url: string, config?: AxiosRequestConfig) {
    return from(this.instance.delete<T, R>(this.addNamespaceUrl(url), config));
  }

  put<T = any, R = T>(url: string, data?: any, config?: AxiosRequestConfig) {
    return from(this.instance.put<T, R>(this.addNamespaceUrl(url), data, config));
  }

  patch<T = any, R = T>(url: string, data?: any, config?: AxiosRequestConfig) {
    return from(this.instance.patch<T, R>(this.addNamespaceUrl(url), data, config));
  }
}
export default Request;
